module.exports = __webpack_public_path__ + "img/fuwu_chuangxin.16666347.png";